export default {
    request(actionUrl, data) {
        let Url = "/api/member/login";

        if (actionUrl == "register") {
            Url = "/api/member/register";
        }

        return axios.post(Url, data);
    },
    sendPwdEmail(data) {
        return axios.post("/api/member/password/email", data);
    },
    sendUsernameEmail(data) {
        return axios.post("/api/member/username/email", data);
    },
    resetPwdEmail(data) {
        return axios.post("/api/member/password/reset", data);
    },
    logout() {
        return axios.post("/api/member/logout");
    },
};
